module.exports = {
  "country": "ES",
  "artist": "Salome",
  "song": "Vivo Cantando",
  "year": "1969",
  "place": "1",
  "spotify": "059G9tpE3kl6wz3kiddaN0"
};